// extracted by mini-css-extract-plugin
module.exports = {"faqItem":"Accordion_faqItem__1ttDX","open":"Accordion_open__C9LJE","faqHeading":"Accordion_faqHeading__2eLHr"};